import { Component, EventEmitter, Output, Input } from '@angular/core';
import { QRButton } from '@base/src/app/models/qr-button.model';

@Component({
  selector: 'app-rendition-update-invoices',
  templateUrl: './rendition-update-invoices.component.html',
  styleUrls: ['./rendition-update-invoices.component.scss'],
})
export class RenditionUpdateInvoicesComponent {
  @Output() actionToDo: EventEmitter<string> = new EventEmitter<string>();
  @Input() isOnlyInvoices: boolean = false;

  buttonInvoices: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Editar facturas',
  };

  onAction() {
    this.actionToDo.emit('invoices');
  }
}
